import { MAX_YEARS_ANTICIPATION, MIN_VALUE_ANTICIPATION, TAX_MONTHLY_RATE } from "../../constants";
import { formatAmount } from "../../utils/formatters";

export const br = {
	test: {
		title: "Test",
		link: "Voltar para Home.",
	},
	basePath: "/fgts",
	components: {
		brandChangeNotification: {
			title: "Estamos mudando pra Vivo Pay!",
			description: "O Vivo Money está virando Vivo Pay. Uma nova marca, com a mesma segurança de sempre",
		},
		tagComingSoon: {
			text: "Em breve",
		},
		navbar: [
			{
				menu: { label: "Empréstimos" },
				subMenu: [
					{
						label: "Empréstimo Pessoal",
						link: "https://www.vivomoney.com.br/emprestimo-pessoal",
						newTab: true,
					},
					{ label: "Antecipação de FGTS", link: "/" },
				],
			},
			{
				menu: { label: "Seguros" },
				subMenu: [
					{
						label: "Seguro Celular",
						link: "https://vivopay.com.br/seguro-celular",
						newTab: true,
					},
					{
						label: "Seguro Eletrônicos",
						link: "https://vivopay.com.br/seguro-eletronicos",
						newTab: true,
					},
					{
						label: "Seguro Residencial",
						link: "https://vivopay.com.br/seguro-residencial",
						newTab: true,
					},
				],
			},
			{
				menu: { label: "Consórcios" },
				subMenu: [
					{
						label: "Consórcio Eletrônicos",
						link: "https://vivopay.com.br/consorcio",
						newTab: true,
					},
					{
						label: "Consórcio Motos",
						link: "https://relevant-concept-074320.framer.app/compra-planejada/moto/vivo",
						newTab: true,
					},
					{
						label: "Seguro Residencial",
						link: "https://www.vivopay.com.br/seguro-residencial",
						newTab: true,
					},
				],
			},
			{
				menu: { label: "Consórcios" },
				subMenu: [
					{
						label: "Consórcio Eletrônicos",
						link: "https://www.vivopay.com.br/consorcio",
						newTab: true,
					},
					{
						label: "Consórcio Motos",
						link: "https://parceria.klubi.com.br/compra-planejada/moto/vivo",
						newTab: true,
					},
				],
			},
			{
				menu: { label: "Outros serviços" },
				subMenu: [
					{
						label: "Crédito Antecipado",
						link: "https://www.vivopay.com.br/credito-antecipado",
						newTab: true,
					},
				],
			},
		],
		buttons: {
			navButtonFixedText: "Pedir empréstimo",
			changeValue: "Alterar valor",
			anticipateFGTS: "Antecipar FGTS",
			anticipateMyFGTS: "Antecipar meu FGTS",
			simulate: "Simular",
			back: "Voltar",
			resendCode: "Reenviar código",
			buttonPrimary: "Continuar",
			buttonSecondary: "Voltar",
			toGoOut: "Sair",
			tryAgain: "Tentar novamente",
			tryAgainV2: "Tentar de novo",
			confirmChange: "Confirmar alteração",
			confirmSign: "Confirmar contratação",
			forgotPassword: "Esqueci minha senha",
			signin: "Entrar",
			myHires: "Minhas contratações",
			callCenter: "Central de atendimento",
			hiring: "Contratações",
		},
		coldSimulationDataCard: {
			title: "Simulação da antecipação do Saque-Aniversário",
			FGTSBalance: "Saldo FGTS",
			birthMonth: "Mês de aniversário",
		},
		coldSimulator: {
			title: "Faça uma simulação e saiba o quanto você pode antecipar",
			fgtsLabel: "Saldo do seu FGTS",
			fgtsHelpText: "Insira o saldo aproximado do seu FGTS",
			fgtsErrorText: `Insira um valor maior que ${formatAmount(MIN_VALUE_ANTICIPATION)}`,
			birthLabel: "Mês de aniversário",
			buttonText: "Simular agora",
		},
		leadSection: {
			title: "Insira seus dados para finalizar sua simulação",
			labelName: "Seu nome",
			labelEmail: "Seu e-mail",
			labelPhone: "Seu celular",
			labelTerms: "política de privacidade",
			labelButton: "Continuar",
			phonePrefix: "+55",
			checkbox: {
				text1: "Declaro que li e estou de acordo com ",
				text2: " da Vivo",
			},
			linkTerms: "#footer",
			linkButton: "#",
			error: {
				name: "Insira seu nome e sobrenome",
				email: "Insira um e-mail válido",
				phone: "Insira um número de celular válido",
			},
		},
		coldSimulationResults: {
			title: "Com a Antecipação de FGTS da Vivo você receberá:",
			FGTSBalance: "Saldo FGTS",
			birthMonth: "Mês de aniversário",
			labelButton: "Antecipar meu FGTS",
		},
		anticipationSimulation: {
			withdrawTitle: "Saque Aniversário",
			anticipationTitle: "Quanto quer antecipar?",
			anticipationWithdraw: `Você pode antecipar até ${MAX_YEARS_ANTICIPATION} anos do Saque-Aniversário o saldo do seu FGTS.`,
			anticipationFees: "Juros de 1,43% ao mês",
			totalReceivable: "Total a receber:",
			maxFGTSValueAvailable: "Antecipe até: ",
			yearsOfAnticipation: (years: number): string => `Antecipação  de ${years > 1 ? years + " anos" : years + " ano"}`,
			collapsibleTitle: "Detalhes da antecipação",
			yearsAnticipation: "Quantos anos deseja antecipar?",
			helperText:
				"Os anos antecipados deixarão seus Saques-Aniversário comprometidos para que a operação deja efetuada",
			year: (years: number): string => `${years > 1 ? "anos" : "ano"}`,
			error: `Valor abaixo do mínimo permitido de ${formatAmount(MIN_VALUE_ANTICIPATION)}`,
		},
		heroSection: {
			title: (bigPayLuck: boolean): string =>
				bigPayLuck ? "Aproveite a Black Friday e Antecipe seu FGTS" : "Antecipe seu FGTS e receba o dinheiro na hora!",
			description: (bigPayLuck: boolean): string =>
				bigPayLuck
					? "Com taxa a partir de 1,29% ao mês, receba o dinheiro que já é seu!\n Por tempo limitado, aproveite!"
					: " ",
			tax: "",
			button: "Antecipar meu FGTS",
		},
		footer: {
			text0: `
				Antecipação de FGTS é o produto de crédito pessoal da TELEFÔNICA BRASIL S/A (Vivo), CNPJ Nº02.558.157/0135-74, 
				com sede na Cidade de São Paulo, Estado de São Paulo, na Av. Engenheiro Luiz Carlos Berrini, 1376, Bairro Cidade Monções, 
				CEP 04571-936 e este faz o uso do saldo FGTS para liquidação da dívida. A Vivo é correspondente bancária da instituição financeira 
				QI SCD, QI SOCIEDADE DE CRÉDITO DIRETO S.A, responsável pela concessão de crédito pessoal, inscrito no CNPJ sob o 
				Nº32.402.502/0001-35 com sede na Avenida Brigadeiro Faria lima, 2.391, 1° andar, CJ 12. A atividade de correspondente 
				bancário é uma atividade regulada pelo Banco Central do Brasil, nos termos da Resolução CMN nº. 4.935, de 29/07/2021. 
				A taxa de juros exercida para este produto financeiro de crédito é fixa, mas podendo ser alterada baseada nas regras do BACEN 
				e/ou políticas internas da VIVO, mas sempre respeitando as regras do BACEN, sendo esta taxa a partir de ${TAX_MONTHLY_RATE} a.m. 
				Prazo pagamento: de 1 ano a 5 anos. O custo efetivo pode variar, sempre a partir de ${TAX_MONTHLY_RATE} a.m. a partir de (16.63% a.a.). A tarifa de cadastro nos produtos de crédito é uma cobrança única em reais e informada no respectivo contrato, destinada a cobrir os custos com a prestação de serviços para confecção de cadastro para início de relacionamento na contratação da sua operação de crédito com a instituição financeira.
				Exemplo: disponibilização de R$ 1075,84 em 7 anos com taxa de juros de ${TAX_MONTHLY_RATE} a.m (16.63% a.a) e CET de 1.82% a.m (24,16% a.a) 
				terá parcelas variáveis conforme regra de saque da CAIXA e um valor total de R$ 1.435,34. Prazos são definidos pelo cliente, 
				porém o limite de crédito é definido conforme saldo disponível de sua conta FGTS.`,
			text1: "Telefônica Brasil S.A CNPJ: 02.558.157/0001- 62. Copyrights © Vivo. Todos os direitos reservados. ",
			text3: "Nossos Termos e Condições",
			list: {
				column_one: {
					title: "Empréstimos",
					link_one: "Nossos termos e condições",
					link_two: "Empréstimo Pessoal",
					link_three: "Antecipação de FGTS",
					link_four: "Crédito do Trabalhador",
				},
				column_two: {
					title: "Seguros",
					link_one: "Seguro Celular",
					link_two: "Seguro Eletrônicos",
					link_third: "Seguro Residencial",
				},
				column_three: {
					title: "Outros serviços",
					link_two: "Compra Planejada",
					link_three: "Crédito Antecipado",
				},
			},
		},
		connectionFeedback: {
			errors: {
				unavailableRealTime: {
					title: "Estamos nos conectando com sua conta do FGTS...",
					text: "Não se preocupe, você receberá uma mensagem por SMS quando a conexão for estabelecida",
				},
				caixaError: {
					title: "Sistema indisponível",
					text: "Não conseguimos estabelecer conexão com o FGTS, tente novamente",
					buttons: {
						primaryButton: "Tentar de novo",
					},
				},
				unauthorizedInstitution: {
					title: "Não conseguimos nos conectar com sua conta FGTS",
					boldText: (isSecondAccount: boolean): string => `“QI Sociedade de Crédito Direto S.A” ${isSecondAccount ? " e “QI Distribuidora de Titulos e Valores Mobiliarios LTDA”" : ""}`,
					firstText: "Vá para o app FGTS e autorize nosso parceiro ",
					lastText: " para continuarmos com a contratação",
					buttons: {
						primaryButton: "Já autorizei",
						linkButton: "Ir para o app FGTS",
						boxedRowTitle: "Saiba como autorizar",
					},
				},
				inexistentAnniversaryMembership: {
					title: "Você não habilitou a modalidade Saque-Aniversário",
					text: "Vá até o aplicativo FGTS e opte pela modalidade Saque Aniversário para conseguirmos consultar o seu saldo",
					buttons: {
						primaryButton: "Tentar de novo",
						linkButton: "Ir para o app FGTS",
					},
				},
				ongoingOperation: {
					title: "Não conseguimos nos conectar com sua conta FGTS",
					text: "Você pode tentar fazer isso novamente mais tarde",
					buttons: {
						primaryButton: "Tentar de novo",
						linkButton: "Sair",
					},
				},
				onLockedDateRange: {
					title: "Não é possível realizar a conexão com seu FGTS hoje",
					text: "Você pode tentar fazer isso novamente no segundo dia útil do próximo mês",
					buttons: {
						primaryButton: "Sair",
					},
				},
				lackPeriod: {
					title: "Você migrou recentemente para o saque-aniversário.",
					text: "Para conseguir antecipar o seu FGTS você deve aguardar o período de carência (90 dias).",
					buttons: {
						primaryButton: "Sair",
					},
				},
				onlyOneOperationAllowedAnually: {
					title: "Você já tem uma Antecipação de FGTS em aberto",
					text: "Para anteciapar de novo, o prazo de quitação do seu contrato atual deve ser menor que 24 meses.",
					buttons: {
						primaryButton: "Sair",
					},
				},
				unavailableFGTS: {
					title: "Ops, estamos fora para manutenção",
					text: "Não conseguimos acessar seu FGTS no momento. Tente novamente mais tarde.",
					buttons: {
						primaryButton: "Sair",
					},
				},
				anniversaryMembershipEgress: {
					title: "Você mudou para a modalidade Saque-Rescisão recentemente",
					text: "Para conseguir antecipar o seu FGTS você deve retornar para a modalidade de Saque-Aniversário",
					buttons: {
						primaryButton: "Tentar de novo",
						linkButton: "Ir para o app FGTS",
					},
				},
				processingPendingChanges: {
					title: "Existem pendências em sua conta FGTS",
					text: "Verifique o que falta em sua conta e retorne quando regularizar",
					buttons: {
						primaryButton: "Sair",
					},
				},
			},
		},
		faq: {
			title: "Dúvidas frequentes sobre a Antecipação de FGTS",
			commonQuestions: (secondAccount: boolean): Array<{question: string; answer: string[] | string}> => [
				{
					question: "Quem pode contratar a Antecipação de FGTS?",
					answer:
						"Pessoas maiores de 18 anos, ou emancipadas, com saldo em contas ativas ou inativas do FGTS que aderiram à modalidade do saque-aniversário. " +
						"Além disso, é necessário ter um valor mínimo de saldo na conta para a contratação.",
				},
				{
					question: "O que é Tarifa de Cadastro?",
					answer: "A tarifa de cadastro nos produtos de crédito é uma cobrança única em reais e informada no respectivo contrato, destinada a cobrir os custos com a prestação de serviços para confecção de cadastro para início de relacionamento na contratação da sua operação de crédito com a instituição financeira.",
				},
				{
					question: "Em quanto tempo após a contratação o dinheiro cai em minha conta?",
					answer: "O Pix cai imediatamente na sua conta, assim que o contrato é assinado.",
				},
				{
					question: "Como serão descontadas as parcelas e quais são as taxas de juros?",
					answer:
						"Para pagar as parcelas não é necessário emitir boletos nem habilitar débito automático para descontar as parcelas: saldo utilizado no " +
						`empréstimo ficará bloqueado na sua conta FGTS já que o seu saque-aniversário irá direto para o banco até toda a sua dívida ser paga. Nossa taxa de juros é a partir de ${TAX_MONTHLY_RATE} a.m.`,
				},
				{
					question: "Se eu for demitido, recebo os 40% de multa do FGTS?",
					answer:
						"Se for demitido enquanto a modalidade Saque Aniversário estiver ativa, você receberá a multa rescisória e não poderá sacar os saldos " +
						"residuais mesmo que você retorne ao Saque-Rescisão. (Lei 8.036/90, Art 20-A, §1º).",
				},
				{
					question: "Posso liquidar/antecipar as parcelas da minha antecipação?",
					answer: "Sim, pela nossa Central de Atendimento.",
				},
				{
					question: "Onde baixar o App FGTS?",
					answer: [
						"Se o seu celular for Android, baixe o aplicativo na Google Play Store.",
						"Agora, se o seu celular for IOS, baixe o aplicativo na App Store.",
					],
				},
				{
					question: "Como saber meu saldo no FGTS?",
					answer:
						"No aplicativo FGTS, após fazer o login com CPF e senha, na aba “Principal” você encontra seu saldo total de FGTS.",
				},
				{
					question: "A Antecipação de FGTS é da Vivo?",
					answer:
						"A Antecipação de FGTS é um produto com a garantia e qualidade Vivo em parceria com a QI Sociedade de Crédito Direto S.A",
				},
				{
					question: "Posso voltar ao Saque-Rescisão após fazer a antecipação?",
					answer:
						"É possível retornar/aderir ao modelo Saque-Rescisão no próprio aplicativo FGTS se não houver " +
						"nenhum contrato de antecipação ativo. Porém a alteração só será efetivada a partir do primeiro dia do 25º " +
						"mês após a data da solicitação de retorno (Lei 8.036/90, Art. 20-C, §1º, inciso I).",
				},
				{
					question: "Posso voltar ao Saque-Rescisão caso ainda não tenha contratado a antecipação?",
					answer:
						"Sim. Se você não contratar nenhuma antecipação, no próprio aplicativo FGTS você pode retornar para o Saque-Rescisão.",
				},
				{
					question: "É possível fazer mais de uma contratação?",
					answer: "Não. De acordo com as novas regras, é permitido realizar apenas 1 operação por ano, independentemente do saldo disponível em sua conta FGTS.",
				},
				{
					question: "Como autorizar a Vivo a consultar meu saldo no FGTS?",
					answer: !secondAccount ? [
						"No aplicativo FGTS, após fazer seu login com CPF e senha;",
						"Vá em “Autorizar bancos a consultarem seu FGTS”;",
						"Clique em “Empréstimo Saque-Aniversário”;",
						"Em seguida, ao final da tela, clique em “Adicionar Instituição”;",
						"No campo digitável, insira “QI Sociedade de Crédito Direto S.A” e clique em “Continuar”;",
						"Clique em “Sim” para autorizar a consulta do seu saldo e pronto!",
					] : [
						"No aplicativo FGTS, após fazer seu login com CPF e senha;",
						"Vá em “Autorizar bancos a consultarem seu FGTS”;",
						"Clique em “Empréstimo Saque-Aniversário”;",
						"Em seguida, ao final da tela, clique em “Adicionar Instituição”;",
						"No campo digitável, insira “QI Sociedade de Crédito Direto S.A”;",
						"Digite a 2ª conta da nossa instituição parceira “QI Distribuidora de Titulos e Valores Mobiliarios LTDA” no campo de busca, selecione a instituição e toque em Continuar;",
						"Clique em “Sim” para autorizar a consulta do seu saldo e pronto!",
					],
				},
			],
		},
		partialAnticipationForm: {
			title: "Informe o quanto deseja antecipar:",
			labelInput: "Valor desejado",
			helperText: `Insira um valor entre ${formatAmount(MIN_VALUE_ANTICIPATION)} e `,
			valueNotReached: `O valor mínimo para antecipação é ${formatAmount(MIN_VALUE_ANTICIPATION)}`,
		},
		simulationSummary: {
			title: "Valor que você vai receber:",
			primaryButton: "Antecipar meu FGTS",
			secondaryButton: "Alterar valor",
		},
		ContractValuesDetails: {
			title: "Detalhes da contratação",
			fields: {
				anticipationDate: "Data da antecipação",
				anticipationValue: "Valor antecipado",
				blockedValue: "Valor bloqueado no FGTS",
				anticipationYears: "Anos antecipados",
				contractFees: "Juros do contrato",
				yearFees: "Taxa de juros anual",
				monthFees: "Taxa de juros mensal",
				iof: "IOF",
				cet: "CET",
				yearsAdvance: "Anos antecipados",
				tacAmount: "Tarifa de cadastro",
			},
			helpText:
				"Este é o valor do seu saldo que será retido para garantir o pagamento da " +
				"sua antecipação de FGTS. Assim você não precisa realizar o pagamento de boletos ou parcelas.",
			helpTacAmount: "A tarifa de cadastro é uma cobrança única usada para cobrir os custos de análise e registro dos seus dados na contratação do serviço.",
		},
		debitFGTSInstallments: {
			status: {
				open: "Em aberto",
				paid: "Paga",
			},
			title: "Débitos em seu FGTS",
			installmentsText: (installment: number): string => `${installment}ª parcela`,
		},
		howToAuthorizeSlide: {
			tag: "Passo ",
			texts: [
				{
					titleInfo: "Baixe o aplicativo FGTS",
					subtitleInfo: "Entre na loja de aplicativos do seu dispositivo e baixe o app “FGTS”, da Caixa",
				},
				{
					titleInfo: "Opte pelo Saque-Aniversário",
					subtitleInfo:
						"No app, entre em “Sistemática de saque do seu FGTS”, leia os termos, toque em Optar pelo Saque-Aniversário e siga as instruções",
				},
				{
					titleInfo: "Acesse o menu Mais",
					subtitleInfo: "Depois de optar pelo Saque-aniversário, acesse o menu “Mais”, na barra inferior",
				},
				{
					titleInfo: "Autorize a consulta do seu saldo FGTS",
					subtitleInfo: "Nessa tela, toque em “Autorização de consulta às informações do FGTS”",
				},
				{
					titleInfo: "Escolha empréstimo saque-aniversário",
					subtitleInfo: "Na tela de autorização para consulta, selecione “Empréstimo Saque-aniversário”",
				},
				{
					titleInfo: "Escolha a Instituição Financeira",
					subtitleInfo: "Na tela de selecionar instituição financeira, toque em “Adicionar instituição +”",
				},
				{
					titleInfo: "Digite nossa instituição parceira",
					subtitleInfo:
						"Digite “QI Sociedade de Crédito Direto S.A no campo de busca”, selecione a instituição e toque em Continuar",
				},
				{
					titleInfo: "Confirme a autorização",
					subtitleInfo: "Toque em “Sim” para autorizar a consulta do seu saldo",
				},
				{
					titleInfo: "Volte aqui nessa página",
					subtitleInfo:
						"Depois de concluir o processo no app FGTS, volte nessa página atual, toque em “Antecipar meu FGTS” e siga as instruções",
				},
			],
			textsSecondAccount: [
				{
					titleInfo: "Baixe o aplicativo FGTS",
					subtitleInfo: "Entre na loja de aplicativos do seu dispositivo e baixe o app “FGTS”, da Caixa",
				},
				{
					titleInfo: "Opte pelo Saque-Aniversário",
					subtitleInfo:
						"No app, entre em “Sistemática de saque do seu FGTS”, leia os termos, toque em Optar pelo Saque-Aniversário e siga as instruções",
				},
				{
					titleInfo: "Acesse o menu Mais",
					subtitleInfo: "Depois de optar pelo Saque-aniversário, acesse o menu “Mais”, na barra inferior",
				},
				{
					titleInfo: "Autorize a consulta do seu saldo FGTS",
					subtitleInfo: "Nessa tela, toque em “Autorização de consulta às informações do FGTS”",
				},
				{
					titleInfo: "Escolha empréstimo saque-aniversário",
					subtitleInfo: "Na tela de autorização para consulta, selecione “Empréstimo Saque-aniversário”",
				},
				{
					titleInfo: "Escolha a Instituição Financeira",
					subtitleInfo: "Na tela de selecionar instituição financeira, toque em “Adicionar instituição +”",
				},
				{
					titleInfo: "Digite nossa instituição parceira",
					subtitleInfo: "Digite “QI Sociedade de Crédito Direto S.A no campo de busca”, selecione a instituição",
				},
				{
					titleInfo: "Digite a 2ª conta da nossa instituição parceira",
					subtitleInfo:
						"Digite “QI Distribuidora de Titulos e Valores Mobiliarios LTDA” no campo de busca, selecione a instituição e toque em Continuar",
				},
				{
					titleInfo: "Confirme a autorização",
					subtitleInfo: "Toque em “Sim” para autorizar a consulta do seu saldo",
				},
				{
					titleInfo: "Volte aqui nessa página",
					subtitleInfo:
						"Depois de concluir o processo no app FGTS, volte nessa página atual, toque em “Antecipar meu FGTS” e siga as instruções",
				},
			],
		},
		withdrawPix: {
			cpfTitular: "CPF do titular",
			keyType: "Tipo de chave",
			cpf: "CPF",
			email: "E-mail",
			cellPhone: "Celular",
			random: "Chave aleatória",
			buttonPrimary: "Continuar",
			errors: {
				invalidPixKey: "Chave pix não encontrada, verifique a informação inserida e tente novamente",
			},
		},
		withdrawResume: {
			sectinons: ["Detalhes da contratação", "Como você vai receber"],
			labels: {
				account: "Conta",
				agency: "Agência",
				anticipationValue: "Valor antecipado",
				anticipationYears: "Anos antecipados",
				bank: "Banco",
				cpf: "CPF",
				institution: "Instituição",
				pixKey: "Chave Pix",
				pixKeyType: "Tipo de chave Pix",
				transferType: "Tipo de transferência",
			},
			checkbox: {
				text1: "Declaro que li e estou de acordo com os termos do ",
				labelTerms: "Contrato de Antecipação de FGTS",
				text2: " da Vivo",
			},
			sellersCode: {
				insertSellersCode: "Inserir código do vendedor",
				modal: {
					title: "Insira o código informado pelo vendedor",
					description: "O código serve apenas para identificar a venda",
					btn_cancel: "Cancelar",
					btn_confirm: "Confirmar",
					remove_title: "Quer excluir esse código do vendedor?",
					btn_remove: "Excluir",
				},
			},
			anticipationYears: (years: number): string => `${years + (years > 1 ? " anos" : " ano")}`,
		},
		InformationAboutFGTS: {
			title: "O que é a Antecipação de FGTS?",
			subtitles: {
				first: "É uma modalidade de crédito para quem tem saldo disponível no FGTS e é optante do saque-aniversário.",
				second: "Você adianta o recebimento do seu saldo do FGTS e o pagamento é descontado automaticamente.",
			},
			firstItem: "Sem cobrança mensal",
			secondItem: `Taxa de ${TAX_MONTHLY_RATE} ao mês`,
			thirdItem: "Antecipe até 5 anos",
			fourthItem: "Aguardar carência mínima de 90 dias",
			buttonPrimary: "Antecipar FGTS agora",
		},
		contractConditions: {
			title: "Confira as condições para antecipar seu FGTS com as novas regras",
			cards: [
				{
					title: "Estar em condição regular na Receita Federal",
				},
				{
					title: "Ser optante do Saque-Aniversário no FGTS",
					helperText:
						"O Saque-Aniversário do FGTS permite ao trabalhador realizar o saque de parte do saldo de sua conta do FGTS, anualmente, no mês de seu aniversário.",
				},
				{
					title: "Ter uma conta corrente ou conta poupança",
				},
				{
					title: "Ter saldo disponível no FGTS (conta ativa ou inativa)",
				},
				{
					title: "Ser cliente Vivo",
				},
				{
					title: "Realizar apenas 1 operação por ano",
				},
			],
			buttonAnticipate: "Antecipar meu FGTS",
		},
		AnticipationAdvantages: {
			title: "Vantagens da Antecipação de FGTS",
			description: "É rápido, descomplicado e não compromete a sua renda",
			texts: [
				{
					titleInfo: "Antecipe até 5 anos",
					desciptionInfo: "Você pode antecipar até 5 anos do Saque-Aniversário com o saldo do seu FGTS",
				},
				{
					titleInfo: "Sem boletos para pagar",
					desciptionInfo: "O pagamento da antecipação será descontado direto do seu saldo FGTS",
				},
				{
					titleInfo: `Taxa de ${TAX_MONTHLY_RATE} ao mês`,
					desciptionInfo: "Na Vivo, você paga menos: as melhores taxas do mercado",
				},
				{
					titleInfo: "Contratação rápida e online",
					desciptionInfo: "Você pode realizar a contratação aqui no site, pelo celular ou em seu computador",
				},
				{
					titleInfo: "Pix instantâneo",
					desciptionInfo: "O dinheiro cai na sua conta na hora, via Pix. É só concluir o contrato e aproveitar",
				},
			],
		},
		addressInputGroup: {
			postalCode: "CEP",
			tooltip: "Use o mesmo CEP que aparece no site dos Correios.",
			linkText: "Não sei meu CEP",
			postalCodeErrorText: "CEP inválido. Dá uma conferida",
			address: "Endereço",
			number: "Número",
			complement: "Complemento",
			neighborhood: "Bairro",
			state: "Estado",
			city: "Cidade",
			addressSpecialCharsError:
				"O campo endereço não deve conter caracteres especiais (como pontos, símbolos, etc). Por favor, remova-os e tente novamente.",
			addressSpecialCharsValidationError:
				"O campo endereço contém caracteres especiais não permitidos (como pontos, símbolos, etc).",
		},
	},
	pages: {
		navigation: {
			anticipation: "Antecipar FGTS",
		},
		home: {
			gtmTitle: "Antecipe seu FGTS com a Vivo",
			gtmDescription:
				"Com a Antecipação de FGTS o cliente Vivo pode antecipar até 5 anos do seu saque-aniversário com contratação 100% digital e recebe seu dinheiro de forma fácil, rápida e segura.",
			howToAuthorizeSlide: {
				title: "Saiba como liberar a contratação da Antecipação de FGTS",
				buttonTitle: "Antecipar meu FGTS",
			},
		},
		simulatorSummary: {
			summaryText: "Resumo da sua solicitação",
		},
		anticipation: {
			header: "Resultado da sua simulação ",
			tabTitle: "Tipo de antecipação:",
			tabs: {
				partial: "Parcial",
				total: "Total",
			},
		},
		connectFGTSBalance: {
			loadingContainerTitle: (option: number): string => {
				if (option === 1) {
					return "Já estamos conectando com sua conta FGTS";
				} else if (option === 2) {
					return "O sistema está um pouco lento. Por favor, aguarde.";
				} else {
					return "Estamos quase lá! Agradecemos sua paciência.";
				}
			},
		},
		authorizationInquiryBalance: {
			screen: "Antecipar FGTS",
			title: "Autorize a consulta do seu saldo FGTS",
			description: [
				"No aplicativo FGTS autorize o acesso do nosso parceiro ",
				"“QI Sociedade de Crédito Direto S.A”",
				" para continuar com a contratação",
			],
			descriptionSecondAccount: [
				"No aplicativo FGTS, autorize o acesso de nosso parceiro:",
			],
			listSecondAccount: [
				"QI Sociedade de Crédito Direto S.A",
				"QI Distribuidora de títulos e valores mobiliários LTDA",
			],
			infoSecondAccount: "Para continuar com a contratação, é necessário autorizar ambos.",
			slot: "Saiba como autorizar",
			textButtonPrimary: "Já autorizei",
			textButtonLink: "Ir para o app FGTS",
			cefSlow:
				"As consultas na Caixa estão um pouco lentas. Se possível, acesse entre 21h e 9h para uma consulta mais rápida.",
		},
		howToAuthorize: {
			screen: "Antecipar FGTS",
			title: "Saiba como autorizar a conexão com sua conta do FGTS",
			titleDesktop: "Saiba como liberar a contratação da Antecipação de FGTS",
			subtitle: "Você precisará acessar o aplicativo FGTS e depois retornar aqui para continuar com a contratação",
			buttonPrimary: "Já autorizei",
			buttonPrimaryDesktop: "Antecipar meu FGTS",
			buttonSecondary: "Ir para o app FGTS",
		},
		withdrawResume: {
			title: "Verifique as informações abaixo",
			description: "Antes de continuar, confirme se está tudo",
			buttonPrimary: "Contratar antecipação",
			buttonSecondary: "Voltar",
			vivoPayAward: {
				title: "Sorte Grande Vivo Pay",
				description: [
					"Ao contratar você automaticamente estará participando da promoção, aceita os",
					"termos e condições do regulamento",
					"e receberá um número da sorte em até 5 (cinco) dias úteis.",
				],
			},
		},
		contractViewer: {
			accountCreation: "Termos de Criação de Conta",
			labelContract: "Contrato de Antecipação de FGTS da Vivo",
			vivoPayAward: "Termos e condições do regulamento Sorte Grande Vivo Pay",
		},
		ValidateTokenOTP: {
			title: "Insira o código enviado por SMS",
			description: "Para redefinir a senha, enviamos um código de 6 dígitos para o seu número cadastrado",
		},
		withdrawPaymentInfo: {
			title: "Conta bancária",
			description: "Insira abaixo seus dados bancários para receber o valor antecipado",
			tabsTitle: ["Transferência por Pix", "Transferência bancária"],
			descriptionMobile:
				"Só aceitamos contas bancárias com a mesma titularidade do CPF utilizado no pedido de antecipação",
			descriptionDesktop: "Só serão aceitas contas bancárias em titularidade do mesmo CPF do pedido de antecipação",
		},
		accessBlocked: {
			title: "Acesso bloqueado",
			description: "Por segurança, seu acesso foi bloqueado por 3 horas. Tente novamente mais tarde",
		},
		errorQueryTimeExpired: {
			title: "O tempo de consulta expirou",
			description: "Refaça a consulta para continuar sua contratação",
			button: "Consultar novamente",
		},
		errorOpenSettlementWithUpperLimit: {
			title: "Você já tem uma Antecipação de FGTS em aberto",
			description: "Para antecipar de novo, o prazo de quitação do seu contrato atual deve ser menor que 24 meses",
			button: "Sair",
		},
		errorOldDocument: {
			title: "Envie um documento mais recente",
			description: "Seu documento deve ter até 10 anos",
			button: "Tentar de novo",
		},
		errorUnderageCustomer: {
			title: "A Antecipação de FGTS só está disponível para maiores de idade",
			description: "Você precisa ter pelo menos 18 anos para pedir",
			button: "Sair",
		},
		systemUnavailable: {
			title: "Sistema indisponível",
			description: "Algo deu errado por aqui. Tente novamente ou volte mais tarde",
		},
		systemMaintenance: {
			title: "Estamos melhorando as coisas por aqui",
			description: "Serviço temporariamente indisponível, em breve a situação estará normalizada",
		},

		errorCustomUnavailable: {
			defaultInfo: {
				title: "Algo deu errado",
				description: "Tente novamente mais tarde",
			},
			contractUnavailable: {
				title: "Contratação em andamento",
				description:
					"Você já possui uma contratação em andamento, por favor aguardar. Caso necessário, tente mais tarde novamente.",
			},
			insufficientBalance: {
				title: "Saldo insuficiente",
				description: "Infelizmente, o saldo solicitado é insuficiente. Tente simular novamente",
			},
			keyPixIncorrect: {
				title: "Tem algo errado com a chave Pix que você informou",
				description: "Vamos voltar algumas etapas. Confira se a chave é válida e se está vinculada ao seu CPF",
				buttonPrimary: "Alterar chave Pix",
			},
		},
		PasswordReset: {
			title: "Crie uma nova senha transacional",
			description: "Ela precisa ter 6 dígitos",
		},
		validateDocumentsHome: {
			title: "Hora de enviar seu documento",
			description: "Agora precisamos validar a sua identidade, tenha em mãos seu RG ou CNH",
		},
		validateDocumentsUnderAnalysis: {
			title: "Documentos enviados pra análise",
			description:
				"Vamos precisar de alguns minutos pra concluir esta etapa. Quando tivermos novidades te avisaremos aqui e por SMS",
			steps: [
				{
					title: "Enviando documentos para análise",
					description: "Continue nessa tela enquanto analisamos",
				},
				{
					title: "Analisando seus documentos",
					description: "A análise pode levar alguns minutos. Vamos avisar você quando estiver tudo pronto",
					loadingText: "Por favor, aguarde",
				},
				{
					title: "Analisando seus documentos",
					description: "A análise pode levar alguns minutos. Vamos avisar você quando estiver tudo pronto",
					loadingText: "Aguarde mais um pouco",
				},
				{
					title: "Analisando seus documentos",
					description: "A análise pode levar alguns minutos. Vamos avisar você quando estiver tudo pronto",
					loadingText: "Aguarde mais um pouco",
					helperText:
						"O tempo de espera está maior que o normal, mas vamos avisar por SMS quando estiver pronto. Você já pode sair dessa tela",
				},
				{
					title: "Analisando seus documentos",
					description: "A análise pode levar alguns minutos. Vamos avisar você quando estiver tudo pronto",
					helperText:
						"Não conseguimos terminar a análise agora, mas vamos avisar por SMS quando estiver pronto. Você já pode sair dessa tela",
				},
			],
		},
		validateDocumentsUnderApproved: {
			title: "Documentos aprovados!",
			description: "Agora você pode seguir com o seu pedido de antecipação de FGTS",
		},
		validateDocumentsUnderRefused: {
			title: "Seus documentos não foram aprovados",
			description: "Por enquanto, não é possível continuar com seu pedido de antecipação de FGTS",
		},
		validateDocumentsResend: {
			title: "Os dados da foto não estão legíveis",
			description:
				"Vá para um ambiente bem iluminado e posicione o seu documento em uma superfície plana. Antes de confirmar o envio, verifique se as informações estão legíveis",
		},
		passwordChangeSuccess: {
			title: "Sua nova senha foi cadastrada!",
			description: "Agora você já pode finalizar a contratação do Empréstimo FGTS",
			button: "Finalizar a contratação agora",
		},
		signContract: {
			subscriptionPassword: {
				title: "Confirme a contratação com a sua senha transacional",
				callout:
					"A senha transacional de 6 dígitos é a senha de segurança que você cadastrou para os todos produtos financeiros da Vivo",
				inputText: "Senha de 6 dígitos",
				errorOfLength: "Sua senha deve conter 6 dígitos",
				errorAttempts: (numberOfAttempts: number): string =>
					`Senha inválida. Você tem mais ${
						numberOfAttempts > 1 ? numberOfAttempts + " tentativas" : numberOfAttempts + " tentativa"
					}`,
			},
			OPTConfirmation: {
				title: "Agora é só confirmar a contratação",
				description: (phone: string): string => `insira abaixo o código que enviamos para o número ${phone}`,
			},
			anticipationFinished: {
				title: "Sua antecipação de FGTS foi realizada!",
				description: "Você vai receber um Pix na conta informada nos próximos minutos.",
				subTitle: "Detalhes da contratação",
				accordionTitle: "Débitos em seu FGTS",
				fields: {
					anticipationValue: "Valor antecipado",
					blockedValue: "Valor bloqueado no FGTS",
					anticipationYears: "Anos antecipados",
					contractFees: "Juros do contrato",
					yearFees: "Taxa de juros anual",
					monthFees: "Taxa de juros mensal",
					iof: "IOF",
				},
			},
			successAlterPassword: {
				title: "Sua nova senha foi cadastrada!",
				description: "Agora você já pode finalizar a contratação do Empréstimo FGTS",
				button: "Finalizar a contratação agora",
			},
		},
		registerSuccess: {
			title: (state: boolean): string =>
				`Tudo certo, seu cadastro foi ${state ? "realizado" : "confirmado"} com sucesso!`,
			description: "Agora você já pode finalizar a contratação do Empréstimo FGTS",
		},
		validateTokenOTPByEmail: {
			title: "Insira o código enviado por e-mail",
			description: "Para redefinir a senha, enviamos um código de 6 dígitos para o seu e-mail cadastrado",
		},
		userRegistrationData: {
			title: "Dados cadastrais",
			description: "Confirme ou insira seus dados para continuar",
			calloutDescription:
				"A alteração dos dados acima refletirá em todos os seus cadastros nos produtos financeiros da Vivo",
		},
		personalAditionalInfo: {
			title: "Dados pessoais",
			description: "Precisamos que informe mais esses dados para continuar",
			fields: {
				birthday: {
					label: "Data de nascimento",
					placeholder: "dd/mm/aaaa",
					name: "bithday",
				},
				motherName: {
					label: "Nome da mãe",
					name: "mother-name",
					placeholder: "Nome da mãe com sobrenome",
					helperText: "Da mesma forma que está em seu documento",
				},
			},
		},
		addressInput: {
			title: "Endereço",
			description: "Informe o seu endereço residencial",
		},
		signInInfo: {
			title: "Vamos te direcionar para a autenticação da Vivo",
			description:
				"Por questões de segurança, precisamos que você se autentique em sua conta Vivo para solicitar a antecipação de FGTS",
			callout: "Essa etapa é importante para garantirmos que ninguém além de você consiga antecipar o seu FGTS",
		},
		expiredToken: {
			title: "Você precisa fazer a autenticação novamente",
			description: "Por razões de segurança, é necessário que você valide seu acesso novamente para continuar",
		},
		homeLogged: {
			title: (name: string): string => `Olá${", " + name}!`,
			bodyText: "Acompanhe as suas contratações ou faça uma nova antecipação",
		},
		callCenter: {
			title: "Precisa de ajuda?",
			description: "Entre em contato com a nossa central de atendimento",
			card: {
				title: "Central de atendimento",
				value: "08000010315",
				helperText: "Atendimento de segunda a sexta, das 8h às 20h (exceto feriados nacionais)",
			},
		},
	},
	atoms: {},
	organisms: {
		inputsNewPassword: {
			label: "Nova senha de 6 dígitos",
			confirmLabel: "Confirme a nova senha",
			errorOfLength: "A sua senha deve ser numérica e com 6 dígitos",
			errorOfMatch: "As senhas digitadas não correspondem",
		},
		pinInput: {
			title: "Digite o código de 6 dígitos",
			tryAgainLabel: "Você pode pedir um novo código em ",
			errorField: (attempts: number): string =>
				attempts === 0
					? "O código informado é inválido, tente novamente"
					: `O código informado é inválido, você tem mais ${attempts === 1 ? "1 tentativa" : `${attempts} tentativas`}`,
		},
		inputsRegistrationData: {
			labelCpf: "CPF",
			labelPhone: "Nº de celular",
			prefixPhone: "+55",
			labelName: "Nome Completo",
			labelEmail: "E-mail",
			errors: {
				invalidName: "Insira seu nome e sobrenome",
				invalidEmail: "E-mail inválido. Dá uma conferida",
			},
		},
		contractItem: {
			description: "Antecipação FGTS",
			inProgress: "Contrato em andamento",
			canceled: "Contrato cancelado",
			finished: "Contrato quitado",
		},
	},
	templates: {
		NewTransactionalPassword: {
			title: "Senha transacional",
			description: "Cadastre uma senha numérica de 6 dígitos",
			calloutDescription:
				"A senha transacional de 6 dígitos é uma senha de segurança que será solicitada para os produtos financeiros da Vivo",
			termsText: ["Li e estou de acordo com os", "Termos de Criação de Conta"],
		},
		CreditProposal: {
			title: "Outras opções de crédito para você",
			description: "No momento essa opção ainda não está disponível",
			offers: "Conheça outras ofertas:",
			tag: "Empréstimo pessoal NoVerde",
			titleCard: "Simule seu empréstimo",
			descriptionCard: "Você ainda pode conseguir um crédito com nosso parceiro",
			buttonTextOnContinue: "Simular proposta",
			buttonTextOnBack: "Sair",
		},
	},
	mappingErrorInterceptor: {
		default: "Houve um erro inesperado. Por favor, tente novamente mais tarde.",
		biometry: "Houve um pequeno problema ao coletar sua biometria. Não se preocupe, tente novamente",
		authentication: "Houve um problema ao tentar realizar o login Vivo Pay. Verifique suas credenciais e tente novamente.",
		simulation: "Infelizmente, não conseguimos processar sua simulação neste momento. Por favor, tente novamente mais tarde.",
		signature: "Houve um problema ao concluir sua assinatura. Tente novamente.",
		password: "Houve um problema ao efetivar sua senha. Verifique se os dados estão corretos e tente novamente.",
		payRegistration: "Houve um problema ao realizar seu cadastro Pay. Por favor, revise suas informações e tente novamente.",
		balanceInquiryRelease: "Aguarde a liberação da consulta pela Caixa Econômica Federal. Se você já solicitou a liberação, sugerimos que aguarde 15 minutos antes de tentar novamente.",
	},
};
